import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EQOColor, EQOIcon, EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';

export interface ISelectWithImage {
	id: number;
	text: string;
	initials: string;
	image: string;
}

@Component({
	selector: 'app-select-with-image',
	templateUrl: './select-with-image.component.html',
	styleUrls: ['./select-with-image.component.scss'],
})
export class SelectWithImageComponent implements OnInit {
	public ICON = EQOIcon;
	public COLOR = EQOColor;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	@Input() public options: ISelectWithImage[] = [];
	@Input() public selectedOption: ISelectWithImage;
	@Input() public maxHeight: number = 250;
	@Input() public title: string;

	@Output() public selectionChanged: EventEmitter<ISelectWithImage> = new EventEmitter();
	public show: boolean = false;

	constructor() {
	}

	public ngOnInit(): void {
	}

}
